import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteTagPayload } from '@app-store/slices/tags/delete'

interface TaskAction extends Action {
    payload: IDeleteTagPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.tags.delete

function* deleteTagSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/tags/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Keyword deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteTagSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteTagSagaTask)
}

export default deleteTagSaga
